// extracted by mini-css-extract-plugin
export var arrow = "_c2-1";
export var content = "_c2-0";
export var highlighted = "_c2-2";